module.exports = __webpack_public_path__ + "static/church-sketch-small-no-bg-4736e2099cf64836165dbf4ac8f40b89.png";